import { useState } from 'react';
// mantine
import { Select, SelectProps } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
// utils
import { usePossibleValuesQuery } from '@/services/possible_values/possible_values.queries.ts';

interface AutocompleteProps extends SelectProps {
    url: string;
}

const DEBOUNCE_TIMEOUT = 500;

const Autocomplete = ({
    value,
    label,
    description,
    onChange,
    withAsterisk,
    error,
    url
}: AutocompleteProps) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm] = useDebouncedValue(
        searchTerm,
        DEBOUNCE_TIMEOUT
    );
    const { data } = usePossibleValuesQuery({
        url,
        params: {
            query: debouncedSearchTerm,
            per: 20
        }
    });

    const options = (data?.items ?? []).map((item) => ({
        label: item.display_value,
        value: item.value
    }));

    return (
        <Select
            clearable
            searchable
            data={options}
            description={description}
            error={error}
            label={label}
            searchValue={searchTerm}
            value={value}
            withAsterisk={withAsterisk}
            onChange={onChange}
            onSearchChange={setSearchTerm}
        />
    );
};

export default Autocomplete;
